import React from 'react';
import AtomSpinner from '../loader/AtomSpinner';

const NeonButton = ({
  children,
  variant = 'primary',
  size,
  block,
  loading,
  disabled,
  onClick,
  type = 'button',
  className = '',
  ...rest
}) => {
  const classes = [
    'neon-btn',
    variant === 'cyan' ? 'btn-cyan' : '',
    variant === 'danger' ? 'btn-danger' : '',
    variant === 'ghost' ? 'btn-ghost' : '',
    size === 'lg' ? 'btn-lg' : '',
    size === 'sm' ? 'btn-sm' : '',
    block ? 'btn-block' : '',
    loading ? 'loading' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || loading}
      onClick={onClick}
      {...rest}
    >
      {loading && <AtomSpinner />}
      {children}
    </button>
  );
};

export default NeonButton;
